import { FC } from "react";
import { MdLocalPhone } from "react-icons/md";
import { useTranslation } from "react-i18next";
import {CheckOutIcon, CheckTimeIcon} from "src/assets/Icons";
import ExtraGuestFeeWarning from "src/Modules/Hotels/Components/ExtraGuestFeeWarning/ExtraGuestFeeWarning";

interface PropertyPoliciesProps {
  checkInTime: string | null;
  checkOutTime: string | null;
  phoneNumber: string | null;
  extraGuestCharges: number | null;
  currency: string | null;
}

const PolicyCard: FC<{ icon: React.ReactNode; label: string; value: string }> = ({ icon, label, value }) => {
  return (
    <div className="flex flex-1 items-center gap-3">
      <div className="shrink-0 bg-background-minimal p-2 text-icon-active rounded-none">{icon}</div>
      <div>
        <p className="text-font-subtle text-xs font-bold uppercase tracking-wide">{label}</p>
        <p className="font-bold text-font-default">{value}</p>
      </div>
    </div>
  );
};

const PropertyPolicies: FC<PropertyPoliciesProps> = ({ checkInTime, checkOutTime, phoneNumber, extraGuestCharges, currency }) => {
  const { t } = useTranslation();
  const showExtraGuestFee = extraGuestCharges !== null && extraGuestCharges > 0;
  const hasAny = checkInTime || checkOutTime || phoneNumber || showExtraGuestFee;
  if (!hasAny) return null;

  return (
    <div>
      <h3 className="mb-4 text-lg font-semibold text-font-default">{t("Hotels.booking.propertyPolicies")}</h3>
      <div className="shadow-card flex flex-col gap-8 rounded-md bg-background-default p-6">
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {checkInTime && <PolicyCard icon={<CheckTimeIcon/>} label={t("Hotels.booking.checkInTimeLabel")} value={checkInTime} />}
          {checkOutTime && <PolicyCard icon={<CheckOutIcon />} label={t("Hotels.booking.checkOutTimeLabel")} value={checkOutTime} />}
          {phoneNumber && <PolicyCard icon={<MdLocalPhone className="h-5 w-5" />} label={t("Hotels.booking.contactNumber")} value={phoneNumber} />}
        </div>
        {showExtraGuestFee && <ExtraGuestFeeWarning extraGuestCharges={extraGuestCharges!} currency={currency ?? undefined} />}
      </div>
    </div>
  );
};

export default PropertyPolicies;
